var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2566 1.304C20.4482 -0.43472 23.0142 -0.43472 24.2058 1.304L29.9449 9.67801C30.335 10.2472 30.9094 10.6645 31.5713 10.8596L41.3089 13.7301C43.3307 14.3261 44.1237 16.7665 42.8383 18.4371L36.6476 26.483C36.2268 27.0299 36.0074 27.7051 36.0264 28.3949L36.3055 38.543C36.3634 40.65 34.2875 42.1583 32.3015 41.452L22.7363 38.0507C22.0862 37.8195 21.3762 37.8195 20.7261 38.0507L11.1609 41.452C9.17489 42.1583 7.09897 40.65 7.15692 38.543L7.43602 28.3949C7.455 27.7051 7.2356 27.0299 6.81481 26.483L0.624128 18.4371C-0.66126 16.7665 0.131675 14.3261 2.15352 13.7301L11.8912 10.8596C12.553 10.6645 13.1274 10.2472 13.5175 9.67801L19.2566 1.304Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.ce60458c766c75cbeb873b0164965035.svg";
export { ForwardRef as ReactComponent };